import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { updateImputationPolicy } from '@ebalance/proto/bffuser/v1/imputation_policy_service-ImputationPolicyService_connectquery'
import {
  UpdateImputationPolicyRequestSchema,
  UpdateImputationPolicyResponseSchema,
} from '@ebalance/proto/bffuser/v1/imputation_policy_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * UpdateImputationPolicy ミューテーションフック。
 * FieldMask (update_mask) を含むリクエストを BFF に送る。
 * onError / onSettled の callbacks は呼び出し側 (useImputationPolicy) で注入する。
 */
export function useUpdateImputationPolicyMutation(): UseMutationResult<
  MessageShape<typeof UpdateImputationPolicyResponseSchema>,
  ConnectError,
  MessageInitShape<typeof UpdateImputationPolicyRequestSchema>
> {
  return useMutation(updateImputationPolicy)
}
